/*
  global
  videojs
*/

import '../../../app.es6';
import angular from 'angular';
import moment from '../../../../node_modules/moment/moment.js';

const COMPONENT_NAME = 'videoGuest';
const FILE_TYPE = 'video/mp4';
const DATE_FORMAT = 'YYYY年MM月DD日';

const INITIAL_STATE_MESSAGE = 'ファイルが選択されていません';

class VideoGuest {
  /* @ngInject */
  constructor ($scope, $sessionStorage, $rootScope, $location, $sce, $timeout, commonApiFactory, commonFactory, Const, SharedState) {
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.$sce = $sce;
    this.$timeout = $timeout;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.Const = Const;
    this.UiSharedState = SharedState;

    this.stateMessage = INITIAL_STATE_MESSAGE;
    this.errorStateMessage = '選択したファイルが不正です。ファイルを選択しなおしてください';
    this.timestamp = new Date().getTime();
    this.errorCount = 0;

    // component state
    this.isUploading = false;
    // this.isFileSelected = false;
    this.isPreview = this.isUploaded;
    this.isInvalidFile = false;
    this.isVideoStopped = true;

    // video info
    this.videoId = '';
    this.fileName = '';
    this.displayStartedDate = '';
    this.isUploaded = false;
    if (this.videoData.getUrls) {
      this.isUploaded = true;
      this.setUploadedVideo();
    }
    VideoGuest.$inject = [
      '$scope', '$sessionStorage', '$rootScope', '$location', '$sce', '$timeout',
      'commonApiFactory', 'commonFactory', 'Const', 'SharedState'
    ];
  }

  play () {
    this.isVideoStopped = false;
    let video = videojs(`video-${this.timestamp}-${this.index}`);
    video.play();
  }

  setUploadedVideo () {
    this.videoId = this.videoData.id;
    if (this.videoData.fileName) {
      this.fileName = this.videoData.fileName;
    } else {
      this.fileName = 'ファイル名を取得できませんでした';
    }
    if (this.videoData.startedDate) {
      this.displayStartedDate = moment(this.videoData.startedDate).format(DATE_FORMAT);
    } else {
      this.displayStartedDate = '撮影日を取得できませんでした';
    }
    this.stateMessage = this.fileName;

    // elementが描画されるのを待つ
    this.$timeout(() => {
      let that = this;
      videojs(`video-${this.timestamp}-${this.index}`).ready(function () {
        let sources = [{'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videoData.getUrls.original)}];
        this.src(sources);
        this.on('play', () => {
          that.isVideoStopped = false;
          that.$scope.$apply();
        });
        let getUrls = that.videoData.getUrls;
        if (getUrls && getUrls.thumb) {
          // サムネイル表示
          this.poster(getUrls.thumb);
        } else {
          console.log('thumb not found [' + that.videoId + ']');
          this.load();
        }
      });
    }, 1000);
    this.isPreview = true;
  }

  // 削除ボタン押下
  delete () {
    this.$rootScope.videoId = this.videoId;
    this.$rootScope.fileIndex = this.index;
    this.$rootScope.fileName = this.fileName;
    this.$rootScope.parentScope = this.$scope;
    this.UiSharedState.turnOn('dialogDeleteVideoPopup');
  }

  // 生徒アカウントへ移動ボタン押下
  moveToMember () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE] = new Date();
    this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER] = this.videoId;
    this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo;
    this.$location.path('/admin/course');
  }

}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME,
      videoData: '=videodata',
      index: '=index',
      removeVideo: '&removevideo'
    },
    controller: VideoGuest,
    templateUrl: 'app/components/video/guest/video-guest.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/video/guest/video-guest.es6